import { c as _c } from "react/compiler-runtime";
import { CircleOffIcon } from "lucide-react";
import Image from "next/image";
import { formatVariantsPriceRange } from "@/lib/financial/money";
import { cn, getProductImages } from "@/lib/utils";
import { BadgeSchema } from "@/ui/store-jsonb-schemas";
import { YnsLink } from "@/ui/yns-link";
import { InlineAddToCart } from "./products/inline-add-to-cart";
export const BlogProductEmbed = async t0 => {
  const $ = _c(19);
  const {
    productIds,
    domain,
    store,
    products
  } = t0;
  if (!products || products.length === 0) {
    return null;
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== domain || $[1] !== productIds || $[2] !== products || $[3] !== store) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t5;
      if ($[8] !== products) {
        t5 = id => products.find(p => p.id === id);
        $[8] = products;
        $[9] = t5;
      } else {
        t5 = $[9];
      }
      const orderedProducts = productIds.map(t5).filter(_temp);
      if (orderedProducts.length === 0) {
        t4 = null;
        break bb0;
      }
      const getGridClasses = _temp2;
      t3 = "my-8 not-prose";
      t1 = cn("grid gap-6", getGridClasses(orderedProducts.length));
      let t6;
      if ($[10] !== domain || $[11] !== store) {
        t6 = product_0 => <BlogProductCard key={product_0.id} product={product_0} domain={domain} store={store} />;
        $[10] = domain;
        $[11] = store;
        $[12] = t6;
      } else {
        t6 = $[12];
      }
      t2 = orderedProducts.map(t6);
    }
    $[0] = domain;
    $[1] = productIds;
    $[2] = products;
    $[3] = store;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[13] !== t1 || $[14] !== t2) {
    t5 = <div className={t1}>{t2}</div>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t3 || $[17] !== t5) {
    t6 = <div className={t3}>{t5}</div>;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};
const BlogProductCard = t0 => {
  const $ = _c(46);
  const {
    product,
    domain,
    store
  } = t0;
  let t1;
  if ($[0] !== product) {
    t1 = getProductImages(product);
    $[0] = product;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const images = t1;
  let t2;
  if ($[2] !== product.badge) {
    t2 = BadgeSchema.safeParse(product.badge ?? {});
    $[2] = product.badge;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const result = t2;
  const badge = result.success && result.data?.content ? result.data : null;
  const firstAndOnlyVariant = product.variants.length === 1 && product.variants[0];
  const searchParams = new URLSearchParams();
  if (firstAndOnlyVariant) {
    firstAndOnlyVariant.combinations.forEach(combination => {
      const key = combination.variantValue.variantType.label;
      const value = combination.variantValue.value;
      searchParams.set(key, value);
    });
  }
  const href = searchParams.size ? `/product/${product.slug}?${searchParams}` : `/product/${product.slug}`;
  const t3 = product.productTaxRate?.taxRate.rate || "0";
  let t4;
  if ($[4] !== product.variants || $[5] !== store.currency || $[6] !== store.locale || $[7] !== store.taxBehavior || $[8] !== t3) {
    t4 = formatVariantsPriceRange({
      taxRate: t3,
      taxBehavior: store.taxBehavior,
      variants: product.variants,
      currency: store.currency,
      locale: store.locale
    });
    $[4] = product.variants;
    $[5] = store.currency;
    $[6] = store.locale;
    $[7] = store.taxBehavior;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const priceRange = t4;
  let t5;
  if ($[10] !== badge) {
    t5 = badge && <span className="z-20 absolute top-3 left-3 text-xs font-medium px-2 py-1 rounded-full" style={{
      backgroundColor: badge.backgroundColor ?? "#FFFFFF",
      color: badge.textColor ?? "#000000"
    }}>{badge.content}</span>;
    $[10] = badge;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== images[0] || $[13] !== images[1] || $[14] !== product.name) {
    t6 = images[0] ? <><Image className="absolute top-0 left-0 z-10 w-full h-full object-cover object-center transition-opacity group-hover:opacity-90" src={images[0]} width={400} height={400} loading="lazy" sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw" alt={product.name} />{images[1] && <Image className="absolute top-0 left-0 z-0 w-full h-full object-cover object-center opacity-0 group-hover:opacity-100 transition-opacity duration-300" src={images[1]} width={400} height={400} sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw" alt={product.name} />}</> : <div className="aspect-square bg-gray-100 flex justify-center items-center"><CircleOffIcon className="text-gray-300 w-12 h-12" /></div>;
    $[12] = images[0];
    $[13] = images[1];
    $[14] = product.name;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== domain || $[17] !== firstAndOnlyVariant || $[18] !== product) {
    t7 = firstAndOnlyVariant && !product.subscription && <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"><div><InlineAddToCart variant={firstAndOnlyVariant} product={product} domain={domain} /></div></div>;
    $[16] = domain;
    $[17] = firstAndOnlyVariant;
    $[18] = product;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t6 || $[21] !== t7) {
    t8 = <div className="relative aspect-square overflow-hidden">{t6}{t7}</div>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== href || $[24] !== t5 || $[25] !== t8) {
    t9 = <YnsLink href={href} prefetch="eager" className="block">{t5}{t8}</YnsLink>;
    $[23] = href;
    $[24] = t5;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== product.name) {
    t10 = <h3 className="text-lg font-semibold text-gray-900 group-hover:text-blue-600 transition-colors line-clamp-2">{product.name}</h3>;
    $[27] = product.name;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== href || $[30] !== t10) {
    t11 = <YnsLink href={href} prefetch="eager">{t10}</YnsLink>;
    $[29] = href;
    $[30] = t10;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== priceRange) {
    t12 = <div className="mt-2 flex items-center justify-between"><span className="text-lg font-bold text-gray-900">{priceRange}</span></div>;
    $[32] = priceRange;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== firstAndOnlyVariant || $[35] !== href || $[36] !== product.subscription || $[37] !== product.variants.length) {
    t13 = (!firstAndOnlyVariant || product.subscription) && <div className="mt-3"><YnsLink href={href} prefetch="eager"><button type="button" className="w-full bg-gray-900 text-white py-2 px-4 rounded-md hover:bg-gray-800 transition-colors text-sm font-medium">{product.variants.length > 1 ? "View Options" : "Learn More"}</button></YnsLink></div>;
    $[34] = firstAndOnlyVariant;
    $[35] = href;
    $[36] = product.subscription;
    $[37] = product.variants.length;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== t11 || $[40] !== t12 || $[41] !== t13) {
    t14 = <div className="p-4">{t11}{t12}{t13}</div>;
    $[39] = t11;
    $[40] = t12;
    $[41] = t13;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== t14 || $[44] !== t9) {
    t15 = <article className="group border border-gray-200 rounded-lg overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow">{t9}{t14}</article>;
    $[43] = t14;
    $[44] = t9;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  return t15;
};
function _temp(product) {
  return product !== undefined;
}
function _temp2(count) {
  switch (count) {
    case 1:
      {
        return "grid-cols-1 max-w-sm mx-auto";
      }
    case 2:
      {
        return "grid-cols-1 sm:grid-cols-2";
      }
    case 3:
      {
        return "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3";
      }
    default:
      {
        return "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3";
      }
  }
}